import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const NineWiket = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
	const load = params.get('load') || '';
	const username = params.get('username') || '';
	const logo = params.get('logo') || '';
	const back = params.get('back') || '';

	const handleBack = () => { 
		if (back) {
			window.location.href = back;
		}
	}

  useEffect(() => {
    const el = document.querySelector('.chat-tongole');
    const prevDisplay = el ? el.style.display : null;
    if (el) el.style.display = 'none';
    return () => {
      const e = document.querySelector('.chat-tongole');
      if (e) e.style.display = prevDisplay || '';
    };
  }, []);

  return (
	  <div className="cdk-overlay-container">
		<div className="launch-game-page" style={{ display: "block" }}>
              <div className="site-top" style={{ display: "block" }}>
                <div className="site-menu no-deposit">
                  <div
                   onClick={handleBack}
                    className="btn"
                    style={{ transform: "translate(0px, 0px)", opacity: 1 }}
                  >
                    <div className="btn-cross" />
                  </div>
                  <div
                    className="info-wrap"
                    style={{
                      display: "block",
                      opacity: 1,
                      transform: "skew(-10.0002deg, 0deg)",
                    }}
                  >
                    <div className="info-block">
                      <div className="info-title">USER</div>
                      <div className="info-value">
                        {username}
                        <span className="info-value-sub ng-star-inserted"></span>
                      </div>
                    </div>
                  </div>
                  <div
                    className="f-logo-bg"
                    style={{ transform: "translate(0px, 0px)", opacity: 1 }}
                  >
                    <div
                      className="f-logo logo-image"
                      style={{ backgroundImage: `url('${process.env.REACT_APP_API_URL}/storage/${logo}')` }}
                    />
                    <div
                      className="light-ring"
                      style={{
                        backgroundImage:
                          'url("https://img.j189eb.com/jb/h5/assets/images/launch-game/icon-light-ring.svg?v=1738666148080")',
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    />
                  </div>
                  <div
                    className="btn"
                    style={{ transform: "translate(0px, 0px)", opacity: 1 }}
                  >
                    <div
                      className="btn-deposit"
                      style={{
                        maskImage:
                          'url("/assets/images/launch-game/icon-deposit.svg")',
                      }}
                    />
                    <div
                      className="light-ring"
                      style={{
                        backgroundImage:
                          'url("https://img.j189eb.com/jb/h5/assets/images/launch-game/icon-light-ring.svg?v=1738666148080")',
                        transform: "translate(0px, 0px)",
                        opacity: 1,
                      }}
                    />
                  </div>
                  <div
                    className="menu-bg"
                    style={{ opacity: 1, height: "100%", width: "100%" }}
                  >
                    <div
                      className="highlight"
                      style={{
                        boxShadow:
                          "inset 0 -1.5px 2.5px 0 rgba(232,206,120, 1), inset 0 1px 3px 0 rgba(255,255,255,.5)",
                        backgroundImage:
                          "inset 0 -1.5px 2.5px 0 rgba(232,206,120, 1), inset 0 1px 3px 0 rgba(255,255,255,.5)",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="top-bg"
                  style={{ transform: "translate(0px, -100px)" }}
                />
              </div>
              <div
                className="site-bg"
                style={{
                  background:
                    "linear-gradient(rgba(5, 5, 5, 0.7) 20%, rgba(232, 206, 120, 0.8) 100%)",
                  display: "block",
                  transform: "translate(0px, 0px)",
                }}
								  />
                  <div
                    className="home-temp-overlay"
                    onClick={handleBack}
                    style={{
                      width: 'calc(100% / 5)',
                      height: '13.33333vw',
                      zIndex: 150000000000,
                      background: 'transparent',
                      position: 'absolute',
                      bottom: 0,
                      right: 0,
                    }}
                  />
                
              <div
                className="launch-game-wrap show"
                style={{ transform: "translate(0px, 0px)" }}
              >
                <iframe
					title="NineWiket"
					name="myiFrame"
					marginHeight="0px"
					marginWidth="0px"
					height="603px"
					width="375px"
					allowFullScreen
					className="launch-game-iframe"
					style={{ border: "0px #ffffff none", width: '100%', height: '100%' , position: 'relative'}}
					scrolling="yes"
					src={load}
				/>
              </div>
            </div>	
		  
    </div>
  );
};

export default NineWiket;
